module.exports = __webpack_public_path__ + "img/comm_12.11ac572d.jpg";